import axios from 'axios';
import config from '../../helpers/config';

export default storeNumbers => (
  axios.get(`${config.designBuilderApiBaseUrl}/${config.designBuilderGetStoreInfo}/${storeNumbers}`)
);

